// 0.5 Hz. WARMUP_TICKS is calibrated for this cadence, so anything scoring with it samples at it.
export const STATS_TICK_INTERVAL_MS = 2_000;
